import { createContext, useContext, ReactNode } from "react";
import { PackageType } from "../services/api/types/assignments/assignment";

interface AssignmentLayoutContextType {
  sidebarContent: ReactNode;
  setSidebarContent: (content: ReactNode) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  // undefined = not yet known (still loading) — the sidebar hides itself
  // until this resolves, rather than flashing SCORM styling by default.
  packageType: PackageType | undefined;
  setPackageType: (packageType: PackageType | undefined) => void;
  // Icon indicators shown in the collapsed sidebar strip (e.g. Acknowledgement/
  // Notes shortcuts) so the learner can see and open them without expanding.
  collapsedContent: ReactNode;
  setCollapsedContent: (content: ReactNode) => void;
  // Which tab the generic expand arrow should land on (vs. the dedicated
  // Acknowledgement/Notes icons, which always pick their own tab).
  setOnExpandDefaultTab: (handler: (() => void) | null) => void;
}

const AssignmentLayoutContext = createContext<
  AssignmentLayoutContextType | undefined
>(undefined);

export const useAssignmentLayout = ():
  AssignmentLayoutContextType | undefined =>
  useContext(AssignmentLayoutContext);

export { AssignmentLayoutContext };
